import React from "react";
import Saves_Money from '../../template/images/Saves Money.png';
import Flexible_Learning from '../../template/images/Flexible Learning.png';
import Get_Certified from '../../template/images/Get Certified.png';
import Curated_by_Experts  from '../../template/images/Curated by Experts.png';
import './home.css';

const UspItems = (props) => {
    const { uspTitle, description } = props;

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp_image_main">
                            <img src={Saves_Money} className="usp_image  img-fluid"></img>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp">
                            <h5 className="usp_title">Saves Money</h5>
                            <p className="us_description">Access quality educational content without breaking the bank, ensuring quality education is affordable for everyone. </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp">
                            <h5 className="usp_title">Flexible Learning </h5>
                            <p className="us_description">Learn at Your Own Pace: Our platform supports self-paced learning, allowing you to progress through courses at a speed that suits your lifestyle and commitments.  </p>
                            <p className="us_description mt-2 mb-2">Course Flexibility: Seamlessly move between multiple courses or switch to different courses as your interests and career goals evolve. </p>
                            <p className="us_description">Customized Learning Solutions: Tailored learning paths and courses designed to meet specific business needs, ensuring that organizational goals are met effectively. </p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp_image_main">
                            <img src={Flexible_Learning} className="usp_image img-fluid"></img>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp_image_main">
                            <img src={Get_Certified} className="usp_image img-fluid"></img>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp">
                            <h5 className="usp_title">Get Certified </h5>
                            <p className="us_description">Certification at No Additional Cost: Earn a certificate for every learning program you complete, without any extra fees, enhancing your resume and proving your expertise.  </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp">
                            <h5 className="usp_title">Curated by Experts  </h5>
                            <p className="us_description">Industry-Expert Courses: Learn from courses curated and taught by real-world experts, ensuring that the knowledge you gain is relevant, current, and practical.</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="usp_inner">
                        <div className="usp_image_main">
                            <img src={Curated_by_Experts } className="usp_image img-fluid"></img>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default UspItems;
